// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSocialMediaFacebook_root__tDw_p"};